<!-- 账户总览 -->

<template>
  <div class="view-container">
    <div class="header-view">
      <div class="user-meg">
        <div class="user-meg-left">
          <img
            src="https://km-renrenxiaoka-resource.oss-cn-shenzhen.aliyuncs.com/template/web/images/common/150-150.png"
            alt="" />
          <div class="acc-view">
            <div class="nick">
              <div>{{ userData.mobile }}</div>
              <!-- level  1-普通用户；2-银牌；3-金牌；4-钻石 -->
              <img :src="levelImage(userData.level)" style="width: 100px; height: auto;" v-if="userData.level">
            </div>
            <div class="acc-num">
              <div>用户编号 {{ userData.userId }}</div>
              <img src="@/assets/image/copy-image.png" alt=""  @click="copyText"/>
            </div>
          </div>
        </div>
        <!-- <div class="user-meg-right">
          <div>安全等级</div>
          <div style="width: 60px; margin-left: 10px">
            <el-progress
              :text-inside="true"
              :stroke-width="10"
              :percentage="50"
              status="exception"
              :show-text="false"
            ></el-progress>
          </div>
        </div> -->
      </div>
      <div class="part-one">
        <div class="part-left">
          <img src="@/assets/image/gonggao.png" alt="" />
          <div>公告</div>
        </div>
        <div class="part-right">
          <el-carousel height="75px" direction="vertical" indicator-position="none" arrow="never">
            <el-carousel-item v-for="item in notices" :key="item">
              <div class="board-item">
                <div class="board-item-wrapper">
                  <div class="board-item-label"
                    style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
                    {{ item.content }}
                  </div>
                </div>
                <div style="font-size: 16px; color: #00000073; margin-top: 5px">
                  {{ item.createTime }}
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="funds-status-container" style="margin-top: 20px;">
    <h2 class="section-title">资金状态</h2>
    <div class="funds-status-grid">
      <!-- 订单核销成功 -->
      <div class="funds-status-card">
        <div class="card-header">
          <span>未结算金额(元)</span>
          <el-tooltip class="item" effect="dark" content="订单核销成功" placement="top">
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <div class="card-value">¥ {{formatCurrency(userData.unsettledAmount)}}</div>
      </div>
      <!-- 可提现金额+安全保障金 -->
      <div class="funds-status-card">
        <div class="card-header">
          <span>已结算金额(元)</span>
          <el-tooltip class="item" effect="dark" content="订单核销总计金额" placement="top">
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <div class="card-value">¥ {{formatCurrency(userData.totalSettAmount)}}</div>
      </div>

      <!-- 账户余额 -->
      <div class="funds-status-card">
        <div class="card-header">
          <span>账户余额(元)</span>
          <el-tooltip class="item" effect="dark" content="可提现金额+安全保障金" placement="top">
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <div class="card-value">¥ {{formatCurrency(userData.balance)}}</div>
      </div>

      <!-- 提现处理中金额 -->
      <div class="funds-status-card">
        <div class="card-header">
          <span>可提现余额(元)</span>
          <el-tooltip class="item" effect="dark" content="可提现余额" placement="top">
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <div class="card-value">¥ {{formatCurrency(userData.canWithdrawBalance)}}</div>
      </div>

      <!-- 冻结金额 -->
      <div class="funds-status-card">
        <div class="card-header">
          <span>冻结金额(元)</span>
          <el-tooltip class="item" effect="dark" content="提现冻结或者其他" placement="top">
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <div class="card-value">¥ {{formatCurrency(userData.auditAmount)}}</div>
      </div>
    </div>

    <div class="action-buttons">
      <el-button type="primary"  @click="accountClick(2)">申请提现</el-button>
    </div>
  </div>
    <!-- 绑定信息 -->
    <div class="account-binding">
      <div style="position: relative;">
        <img src="../../assets/newImage/编组 21备份@2x.png" style="width:100%; height: 100px; object-fit: cover;" alt="">
      <div class="binding-item" >
        <div style="color: #000000;">
          <div>手机绑定</div>
          <div style="margin-top: 10px; color: #6D6D6D; ">
            {{ userData.mobile }}
          </div>
        </div>
      </div>
      </div>
      <div style="position: relative;">
        <img src="../../assets/newImage/编组 19备份 8@2x.png" style="width: 100%; height: 100px; object-fit: cover;">
      <div class="binding-item" >
        <div style="color: #000000;">
          <div>实名认证</div>
          <div style="margin-top: 10px; color: #6D6D6D;" v-if="userData.credentialLevel ==2">
            已实名认证
            <a data-v-7170db1d="" class="link" @click="accountClick(5.4)"> 查看认证</a>
          </div>
          <div style="margin-top: 10px; color: #6D6D6D;"  v-if="userData.credentialLevel ==0" >
            开始初级认证
            <a data-v-7170db1d="" class="link" @click="accountClick(5.4)"> 去认证</a>
          </div>
          <div style="margin-top: 10px; color: #6D6D6D;" v-else-if="userData.credentialLevel ==1" >
            开始高级认证
            <a data-v-7170db1d="" class="link" @click="accountClick(5.4)"> 去认证
            </a>
          </div>
        </div>
      </div>
      </div>
      <div style="position: relative;">
        <img src="../../assets/newImage/编组 19备份 5@2x.png" style="width: 100%; height: 100px; object-fit: cover;">
      <div class="binding-item" >
        <div style="color: #000000; ">
          <div>登录密码</div>
          <div style="margin-top: 10px; display: flex; align-items: center;  color: #6D6D6D;">
            {{ userData.isSetLoginPassword ? "已设置登录密码" : "未设置登录密码" }}
            <div data-v-7170db1d="" @click="accountClick(5.3)" class="link"> {{ !userData.isSetLoginPassword ? "设置密码":"修改密码"}}</div>
          </div>
        </div>
      </div>
      </div>
      <div style="position: relative;">
        <img src="../../assets/newImage/编组 19备份 7@2x.png" style="width: 100%; height: 100px; object-fit: cover;">
      <div class="binding-item" >
        <div style="color: #000000;">
          <div>交易密码</div>
          <div style="margin-top: 10px;color: #6D6D6D;">
            {{ userData.isSetFundPassWord ? "已设置交易密码" : "未设置交易密码" }}
            <a data-v-7170db1d="" class="link" v-if="userData.isSetFundPassWord" @click="accountClick(5.33)">
              {{ userData.isSetFundPassWord ? "修改密码" : "设置密码" }} </a>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http/axios";

export default {
  data() {
    return {
      notices: []
    }
  },
  mounted() {
    this.getNoticeList();
  },

  props: {
    userData: {
      type: Object,
      default: () => ({
        userId: '',
        mobile: '',
        level: 1,
        isSetLoginPassword: false,
        isSetFundPassWord: false,
        credentialLevel: 0,
        unsettledAmount: 0,
        totalSettAmount: 0,
        balance: 0,
        canWithdrawBalance: 0,
        auditAmount: 0
      })
    }
  },
  methods: {
    levelImage(level) {

    switch (level.toString()) {
      case '1':
        return require('../../assets/newImage/putong.png'); // 普通用户图片
      case '2':
        return require('../../assets/newImage/yinpai.png'); // 银牌用户图片
      case '3':
        return require('../../assets/newImage/jinpai.png'); // 金牌用户图片
      case '4':
        return require('../../assets/newImage/zuanshi.png'); // 钻石用户图片
      default:
        return require('../../assets/newImage/zuanshi.png'); // 默认普通用户
    }
  },

    formatCurrency(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    applyWithdraw() {
      // Handle apply withdraw action
    },
    settlement() {
      // Handle settlement action
    },

   // 复制用户编号

   copyText() {
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', '用户编号:'+this.userData.userId );
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success("复制成功")

    },



    // 0修改密码
    accountClick(vl) {
      localStorage.removeItem('tab')
      let v = vl
      if (vl == 5.33) {
        v = 5.3;
        localStorage.setItem('tab', "2");
      }
      this.$emit('accountClick', v)
    },
    getNoticeList() {
      http.get("/article/notice/list", { pageSize: 3, pageNum: 1 }).then((response) => {
        if (response.code === 200) {
          response.rows.forEach(item => {
            item.content = item.content.replace(/<[^>]*>?/g, '');
          });
          response.rows.forEach(item => {
            item.createTime = item.createTime.split(' ')[0];
          });
          this.notices = response.rows;
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.view-container {
  .header-view {
    height: 191px;
    background-color: white;
    border-radius: 10px;
    padding: 0px 16px;

    .user-meg {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e0e0e0;

      .user-meg-left {
        display: flex;
        align-items: center;

        img {
          height: 78px;
          width: 78px;
        }

        .acc-view {
          margin-left: 10px;
          .flex-column();
          justify-items: center;

          .nick {
            color: #1f1f1f;
            font-size: 24px;
            font-weight: 500;
            line-height: 33px;
            display: flex;
            align-items: center;

            img {
              width: 24px;
              height: 28px;
              margin-left: 20px;
            }

            .level-1 {
              background: linear-gradient(90deg, #f5fffe, #cae9fc);
              border-radius: 4px;
              color: #072a62;
              font-size: 14px;
              font-weight: 700;
              height: 26px;
              line-height: 26px;
              text-align: center;
              padding-right: 5px;
            }
          }

          .acc-num {
            margin-top: 10px;
            display: flex;
            align-items: center;
            color: #595959;
            font-family: PingFang SC, sans-serif;
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;

            img {
              height: 24px;
              width: 24px;
              margin-left: 5px;
            }
          }
        }
      }

      .user-meg-right {
        display: flex;
        align-items: center;
        color: #595959;
        font-family: PingFang SC, sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
      }
    }

    .part-one {
      height: 90px;
      display: flex;
      align-items: center;

      .part-left {
        display: flex;
        align-items: center;
        border-right: 2px solid #e0e0e0;

        img {
          height: 32px;
          width: 32px;
        }

        color: #595959;
        font-size: 18px;
        font-weight: 500;
        padding-right: 12px;
      }

      .part-right {
        flex: 1;

        .board-item {
          margin-left: 10px;
          display: flex;
          align-items: center;
          height: 100%;
          justify-content: space-between;

          .board-item-wrapper {
            display: flex;
            width: 75%;
            flex-direction: column;
            justify-self: center;

            .board-item-label {
              .text-one-line();
              font-size: 14px;
              color: #00000073;
            }
          }
        }
      }
    }
  }

  .account-balance {
    display: flex;
    margin-top: 20px;

    display: flex;
    align-items: center;
    justify-content: space-evenly;

    .account-balance-item {
      color: #595959;
      font-size: 16px;
      font-weight: 400;
      background-color: white;
      border-radius: 10px;
      flex: 1;
      height: 100%;
      padding: 0px 20px;
      .flex-column ();
      padding-bottom: 20px;
      position: relative;

      .renminbi-image {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 10px;
        .flex-row-ct();

        img {
          height: 94px;
          width: 92px;
        }
      }

      .blue-bj-btn {
        width: 101px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 16px;
        border: 1px solid #488eff;
        border-radius: 5px;
        color: #488eff;
      }
    }
  }

  .account-binding {
    margin-top: 30px;
    background-color: #ECF2FE;
    border-radius: 10px;
    padding: 20px 0px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* 两列 */
    grid-template-rows: repeat(3, auto);
    /* 三行 */
    gap: 20px;

    /* 子元素之间的间距 */
    .binding-item {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 0px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 5px;
      height: 100px;
      font-size: 16px;

      .link {
        color: #488eff;
        cursor: pointer;
        font-family: PingFang SC, sans-serif;
        font-size: 16px;
        font-weight: 400;
        margin-left: 12px;
      }

      img {
        height: 100px;
        width: 143px;
      }
    }
  }
  .funds-status-container {
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  position: relative;
}

.section-title {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.funds-status-grid {
  display: flex;
  align-items: center;
  justify-content:space-evenly;
  border-top: 1px solid #e0e0e0;
  padding-top: 20px;
}

.funds-status-card {
  padding: 15px;
  border-radius: 8px;
  // background-color: #f9f9f9;
  // box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

  .card-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    span {
      margin-right: 5px;
      font-size: 14px;
      color: #666;
    }

    i {
      color: #999;
      cursor: pointer;
    }
  }

  .card-value {
    font-size: 22px;
    font-weight: 600;
    color: #333;
  }
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;

  .el-button {
    min-width: 100px;
  }
}

/* Make all cards consistent width */
.funds-status-card {
  width: 100%;
  min-height: 100px;
}
}
</style>
